import { useNavigate } from "react-router-dom";
import { Button, ButtonSize, ButtonVariant } from "shared/components";
import SuccessIcon from "shared/icons/status-icons/success-icon.svg?react";
import { Applicant } from "types/application";
import { Minus } from "untitledui-js-base";

interface CanadianCriminalReportSliceProps {
  applicant: Applicant;
  applicationId: string;
  isNotResident: boolean;
}

export const CanadianCriminalReportSlice = ({
  applicant,
  applicationId,
  isNotResident
}: CanadianCriminalReportSliceProps) => {
  const navigate = useNavigate();

  if (isNotResident)
    return (
      <div className="w-full h-full flex flex-col items-center justify-center gap-6">
        <div className="w-16 h-16 bg-[#1C1D2205] rounded-full flex items-center justify-center">
          <Minus className="stroke-content-100 w-4 h-4" />
        </div>
        <p className="text-content-300 text-sm font-medium my-2 text-center max-w-[432px]">
          Report was not ran because applicant wasn’t a current Canadian
          resident or had a previous Canadian address
        </p>
      </div>
    );

  return (
    <div className="w-full h-full flex flex-col items-center justify-center gap-6">
      <div className="w-16 h-16 bg-success-50 rounded-full flex items-center justify-center">
        <SuccessIcon className="w-5 text-success-600" />
      </div>
      <div className="space-y-2 text-center max-w-[432px]">
        <h1 className="text-base font-bold text-content-1000">
          Criminal report (CA) was ran
        </h1>
        <p className="text-content-300 text-sm font-medium">
          Canadian criminal report was ran and a PDF is available for review in
          the additional documents section
        </p>
      </div>

      <Button
        variant={ButtonVariant.PRIMARY}
        size={ButtonSize.SM}
        onClick={() =>
          navigate(
            `/applications/${applicationId}/reports?applicantId=${applicant.id}&report=additional_documents`
          )
        }
      >
        Open additional documents
      </Button>
    </div>
  );
};
